import styled from "styled-components";
import { colors } from "constants/colors";
import { styleSizes } from "constants/styleSizes";
import noRoomsPicture from "assets/images/noRoomsAvailable.jpg";

export const BasicSectionContainer = styled.section`
  width: 100%;
  box-sizing: border-box;

  // Draw disc instead of squere in password fields
  input[type="password"] {
    -webkit-text-security: disc !important;
  }
  input[type="password"] {
    font-family: "Arial", "sans-serif" !important;
    font-size: 20px;
  }
  input[type="password"]::placeholder {
    font-family: "Titillium Web", sans-serif;
    font-size: 16px;
  }

  .cardContent {
    min-width: 260px;
    -webkit-box-shadow: 0px 1px 3px 0px ${colors.accounMenuBorderShadowColor};
    -moz-box-shadow: 0px 1px 3px 0px ${colors.accounMenuBorderShadowColor};
    box-shadow: 0px 1px 3px 0px ${colors.accounMenuBorderShadowColor};
    border: 1px solid ${colors.signInBorderColor};
    padding: 32px;
    display: flex;
    flex-direction: column;
    align-items: stretch;
    align-content: stretch;
    flex: 1;
    color: ${colors.almostBlack};

    @media (max-width: ${styleSizes.mobileBreakpoint}) {
      padding: 0;
      border: 0;
      -webkit-box-shadow: none;
      -moz-box-shadow: none;
      box-shadow: none;
    }
  }

  .innerContainer {
    width: 100%;
    max-width: 1229px;
    box-sizing: border-box;
    padding: 0 31px;
    position: relative;
    overflow: visible;

    @media only screen and (max-width: ${styleSizes.mobileBreakpoint}) {
      padding: 0 24px;
      min-width: 320px;
    }
  }
  .commonTitle {
    width: 100%;
    font-size: 32px;
    text-align: left;
    font-weight: 600;
    color: ${colors.almostBlack};
    margin: 0 0 35px 0;
    padding: 0;
  }

  .confirmed {
    color: ${colors.optionBackground};
  }

  .incomplete {
    color: ${colors.red};
  }

  .checkedIn {
    color: ${colors.hoverBlue};
  }

  .checkedOut {
    color: ${colors.black};
  }

  .cancelled {
    color: ${colors.red};
  }

  .expired {
    color: ${colors.badge};
  }

  a {
    color: ${colors.hoverBlue};
    &:hover {
      color: ${colors.iconBlue};
    }
  }
`;

export const BookingOverlay = styled.div`
  display: none;

  @media only screen and (max-width: ${styleSizes.miniBreakpoint}) {
    display: block;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: ${colors.mobileBookingOverlay};
    z-index: 1800;
    opacity: 0;
    pointer-events: none;
    transition: opacity 0.4s cubic-bezier(0.4, 0, 0.2, 1) 0.1s;

    &.visible {
      opacity: 1;
      pointer-events: all;
      transition: opacity 0.4s cubic-bezier(0.4, 0, 0.2, 1);
    }
  }
`;

export const BookingSummarySlot = styled.div`
  display: none;

  @media only screen and (max-width: ${styleSizes.miniBreakpoint}) {
    display: block;
    flex: none;
    width: 100%;
    height: 0;
    overflow-anchor: none;

    &.reserved {
      height: var(--summary-slot-height, 0px);
    }
  }
`;

export const BookingSummaryContainer = styled.div`
  flex-basis: 40%;
  min-width: 400px;
  margin: 121px 0 40px 0;
  background-color: ${colors.white};
  border: 1px solid ${colors.signInBorderColor};
  padding: 32px;
  display: flex;
  flex-direction: column;
  box-shadow: ${colors.accounMenuBorderShadowColor} 0px 0px 3px 0px;
  position: relative;

  &.lastStep {
    margin: 142px 0 180px 0;
    @media only screen and (max-width: ${styleSizes.tabletBreakpoint}) {
      margin: 0 0 0 0;
    }
    @media only screen and (max-width: ${styleSizes.miniBreakpoint}) {
      margin: 0 0 0 0;
      padding: 24px;
    }
  }

  @media only screen and (max-width: 1100px) {
    flex-basis: 50%;
  }

  @media only screen and (max-width: ${styleSizes.miniBreakpoint}) {
    min-width: auto;
    display: flex;
    flex-direction: column;
    position: fixed;
    bottom: -1px;
    left: 0;
    right: 0;
    z-index: 1900;
    overflow-y: auto;
    margin: 0;
    padding: 24px;
    background: ${colors.white};
    transition: transform 0.45s cubic-bezier(0.4, 0, 0.2, 1);
    will-change: transform;
    max-height: calc(100vh - 70px);
    height: auto;
    transform: translateY(0);

    min-height: 400px;

    &.collapsed {
      transform: translate3d(0, calc(100% - 115px + 1px), 0);
      padding: 24px;
      overflow-y: hidden;
      box-shadow: 0 0 10px ${colors.mobileBoxBookingShadow};

      .controls {
        margin-top: 16px;
      }

      .swipeToHide {
        margin-top: -10px;
      }
    }
  }

  .yourCardWillNotBeCharged {
    margin-top: 20px;
  }

  .bookingMobileContentDetails {
    display: flex;
    flex-direction: column;
  }

  &.mobileFlowSummary .closedContent {
    display: none;
  }

  .flowSummaryTitleOnly {
    display: none;
  }

  @media only screen and (max-width: ${styleSizes.miniBreakpoint}) {
    &.mobileFlowSummary {
      box-sizing: border-box;
      flex: none;
      align-self: flex-start;
      width: calc(100% + 62px);
      margin: 0 -31px;
      position: sticky;
      bottom: calc(var(--summary-peek-height, 115px) - var(--summary-height, 115px) + var(--summary-viewport-inset, 0px));
      left: auto;
      right: auto;
      min-height: 0;
      max-height: none;
      overflow: visible;
      transform: none;
      transition: none;
      will-change: auto;
      padding: 24px 24px calc(24px + env(safe-area-inset-bottom, 0px));
      overflow-anchor: none;

      > * {
        flex-shrink: 0;
      }

      .swipeToHide {
        order: -2;
        margin-top: -10px;
        touch-action: none;
      }

      .controls {
        order: -1;
        margin-top: 16px;
      }

      .closedContent {
        display: block;
      }

      .bookingMobileContentDetails {
        margin-top: calc(24px + env(safe-area-inset-bottom, 0px));
      }

      .swipeToHide,
      .controls {
        transition: opacity 300ms ease-in-out;
      }

      &.summaryFadingOut {
        .swipeToHide,
        .controls {
          opacity: 0;
          pointer-events: none;
        }
      }

      @media (prefers-reduced-motion: reduce) {
        .swipeToHide,
        .controls {
          transition: none;
        }
      }

      &.summaryInFlow {
        border-color: transparent;
        border-top-color: ${colors.signInBorderColor};
        box-shadow: none;

        .swipeToHide,
        .mobileTotals {
          display: none;
        }

        .bookingMobileContentDetails {
          margin-top: 0;
        }

        .flowSummaryTitle {
          display: flex;
          align-items: center;
          box-sizing: border-box;
          min-height: var(--summary-header-height, 0px);
          font-size: 24px;
          font-weight: 600;
          color: ${colors.almostBlack};
          margin: 0;
          padding: 0 0 16px 0;
        }

        .controls {
          order: 1;
          margin-top: 24px;
          justify-content: flex-end;
        }
      }

      &.summaryOverlay {
        position: fixed;
        width: 100%;
        margin: 0;
        left: 0;
        right: 0;
        bottom: var(--summary-viewport-inset, 0px);
        max-height: max(0px, calc(var(--summary-viewport-height, 100vh) - 70px));
        overflow-y: auto;
        overscroll-behavior-y: contain;
        touch-action: pan-y;
      }
    }
  }

  @media only screen and (max-width: ${styleSizes.mobileBreakpoint}) {
    &.mobileFlowSummary {
      width: calc(100% + 48px);
      margin-left: -24px;
      margin-right: -24px;

      &.summaryOverlay {
        width: 100%;
        margin: 0;
      }
    }
  }

  .bookingMobileContentShort {
    display: flex;
    flex-direction: column;
  }

  .swipeToHide {
    cursor: pointer;
    display: none;
    margin-top: -20px;
    font-size: 12px;
    font-weight: 600;
    color: ${colors.borderGrey};
    user-select: none;
    @media only screen and (max-width: ${styleSizes.miniBreakpoint}) {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 8px;
    }
    .swipeToHideHr {
      width: 90px;
      height: 3px;
      background-color: ${colors.lightGrey};
    }
  }
  .editTrip {
    cursor: pointer;
    align-items: center;
    font-size: 15px;
    font-weight: 400;
    color: ${colors.hoverBlue};
    text-decoration: underline;
  }

  .datesTable {
    margin-top: 32px;
    width: 100%;
    .hdr {
      white-space: nowrap;
      padding-bottom: 15px;
      font-weight: 600;
      font-size: 16px;
    }
    .data {
      font-size: 16px;
      @media only screen and (max-width: ${styleSizes.mobileBreakpoint}) {
        font-size: 14px;
      }
    }
    .dataRt {
      text-align: right;
    }
  }

  .datesTableNoMargin {
    margin-top: 0!important;
  }

  /* .roomNights {
      font-weight: 600;
    } */

  .breakdownTable,
  .totalTable {
    padding-top: 0;
    font-size: 16px;
    width: 100%;

    .totalsRN {
      font-weight: 600;
    }
    td {
      padding-bottom: 8px;
    }

    .line {
      display: flex;
      align-items: center;
      justify-content: space-between;
      //hite-space: nowrap;
      @media only screen and (max-width: ${styleSizes.mobileBreakpoint}) {
        font-size: 16px;
      }
    }

    .label {
      padding-right: 10px;
      display: flex;
      flex-direction: row;
      align-items: center;
      gap: 8px;
      br {
        display: none;
        @media only screen and (max-width: ${styleSizes.wideScreenBreakpoint}) {
          display: block;
        }
      }
      @media only screen and (max-width: ${styleSizes.mobileBreakpoint}) {
        font-size: 14px;
      }
    }

    .dots {
      // Uncomment it to return dots back
      //
      /* flex-grow: 1;
      border-bottom: 1px dotted #aaaaaa;
      margin: 0 10px;
      height: 1px;
      transform: translateY(-1px);
      display: none;
      @media only screen and (max-width: ${styleSizes.mobileBreakpoint}) {
          display: flex;
        } */
    }
    .price {
      text-align: right;
      white-space: nowrap;
    }

    .totalPrice {
      text-align: right;
      white-space: nowrap;
      font-size: 18px;
      @media only screen and (max-width: ${styleSizes.mobileBreakpoint}) {
        font-size: 16px;
      }
    }

    .total {
      font-weight: 600;
    }
  }

  .totalTable {
    .payNow {
      color: ${colors.optionBackground}!important;
    }
    .topPart {
      padding-top: 0;
    }
    font-size: 16px;
  }

  /* .card {
    padding: 32px;
    @media only screen and (max-width: 767px) {
      margin-bottom: 0;
    }
  } */

  .title {
    font-size: 24px;
    margin: 10px 0 0 0;
    font-weight: 600;
    @media only screen and (max-width: ${styleSizes.tabletBreakpoint}) {
      font-size: 20px;
    }
    @media only screen and (max-width: ${styleSizes.miniBreakpoint}) {
      display: none;
    }
  }
  .titleStep2 {
    font-size: 24px;
    margin: 10px 0 0 0;
    font-weight: 600;
    @media only screen and (max-width: ${styleSizes.miniBreakpoint}) {
      font-size: 20px;
      margin: 10px 0 0 0;
    }
  }

  .separator {
    height: 1px;
    width: 100%;
    border-top: 1px solid ${colors.signInBorderColor};
    margin-top: 32px;
    margin-bottom: 32px;
    @media only screen and (max-width: ${styleSizes.mobileBreakpoint}) {
      margin-top: 16px;
      margin-bottom: 16px;
    }
  }
  .separatorNoline {
    margin-top: 32px;
  }

  .separatorCoupon{
    margin: 32px 0 0 0!important;
  }
  .booking {
    font-size: 16px;
    margin: 0 0 16px 0;
    font-weight: 600;
    @media only screen and (max-width: ${styleSizes.mobileBreakpoint}) {
      font-size: 18px;
      margin: 16px 0 16px 0;
    }
  }

  .note {
    font-size: 16px;
    line-height: 24px;
    margin: 24px 0 0 0;
    span {
      color: ${colors.red};
      font-weight: 600;
    }
    b {
      font-weight: 600;
    }
    @media only screen and (max-width: ${styleSizes.miniBreakpoint}) {
      margin: 16px 0 0 0;
    }
  }
  .bookingDates {
    margin-bottom: 24px;
    margin-top: 24px;
    input {
      height: 48px;
    }
    @media only screen and (max-width: ${styleSizes.miniBreakpoint}) {
      margin-top: 8px;
      margin-bottom: 8px;
    }
  }

  .guestOption {
    @media only screen and (max-width: ${styleSizes.miniBreakpoint}) {
      margin: 8px 0 16px 0 !important;
    }
  }
  .roomOption {
    @media only screen and (max-width: ${styleSizes.miniBreakpoint}) {
      border-bottom: 1px solid ${colors.checkOutTableTextColor}!important;
      padding-bottom: 16px;
      margin: 0;
    }
  }

  .guestOption,
  .roomOption {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 12px 0;
    //padding: 5px 0;
    border-bottom: 1px solid ${colors.checkOutTableTextColor};
    @media only screen and (max-width: ${styleSizes.miniBreakpoint}) {
      border-bottom: none;
      margin: 0;
    }

    .text {
      .optionTitle {
        font-size: 16px;
        height: 28px;
        line-height: 21px;
        font-weight: 600;
        margin-bottom: 7px;
        color: ${colors.almostBlack};
        @media only screen and (max-width: ${styleSizes.miniBreakpoint}) {
          font-size: 14px;
          display: flex;
          flex-direction: column;
          justify-content: center;
          height: auto;
        }
      }

      .optionDescription {
        font-size: 16px;
        font-style: italic;
        color: ${colors.noBookingText};
        margin-bottom: 8px;
        @media only screen and (max-width: ${styleSizes.miniBreakpoint}) {
          display: none;
        }
        @media only screen and (max-width: ${styleSizes.tabletBreakpoint}) {
          font-size: 14px;
        }
      }
    }

    .optionButtons {
      display: flex;
      justify-content: space-between;
      align-items: center;

      .quantity {
        text-align: center;
        width: 30px;
        height: 30px;
        line-height: 30px;
        font-size: 16px;
        font-weight: 600;
      }
    }

    .disabled {
      g,
      line {
        stroke: ${colors.signInBorderColor};
      }
    }
  }

  .guestOptionAdults,
  .guestOptionChildren {
    .text {
      text-align: right;
      flex: 1;
      margin-right: 24px;
      font-size: 16px;
      font-weight: 400;
    }
  }

  .guestOptionAdults {
    border-bottom: 0;
    @media only screen and (max-width: ${styleSizes.miniBreakpoint}) {
      margin-top: -45px !important;
      margin-bottom: 4px !important;
    }
  }

  .guestOptionChildren {
    padding-bottom: 12px;
    @media only screen and (max-width: ${styleSizes.miniBreakpoint}) {
      margin-bottom: 0 !important;
    }
  }

  .guestOptionCount {
    border-bottom: 0;
    margin: 12px 0 0 0;
    @media only screen and (max-width: ${styleSizes.miniBreakpoint}) {
      margin-top: 8px !important;
    }
  }

  .controls {
    display: flex;
    flex-direction: row;
    justify-content: space-between;

    margin-top: 32px;

    .mobileTotals {
      display: flex;
      flex-direction: column;
      justify-content: center;
      gap: 8px;
      .mobileTotalsTotal,
      .mobileTotalsGuests {
        font-size: 14px;
        font-weight: 400;
        span {
          font-size: 16px;
          font-weight: 600;
          margin-left: 8px;
        }
      }
    }
  }
  .noControls {
    margin-top: 0;
    @media only screen and (max-width: ${styleSizes.miniBreakpoint}) {
      margin-top: 32px;
    }
  }

  .total {
    font-weight: 600;
    padding-top: 8px;
    padding-bottom: 0 !important;
    width: 100%;
  }

  .priceDetails {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 10px 0;
    padding: 5px 0;
    border-bottom: 1px solid ${colors.checkOutTableTextColor};

    .text {
      font-size: 14px;
      font-weight: 600;
    }

    .price {
      font-size: 18px;
      font-weight: 600;
    }
  }

  .termsOfServices {
    margin: 10px 0 0 0;
  }

  .termsOfServiceContainer {
    width: 100%;
    padding: 10px 8px;
    margin: 0;

    .required {
      margin-top: 8px;
      color: ${colors.red};
      font-size: 16px;
    }

    .termsOfService {
      display: flex;

      .text {
        margin-left: 5px;

        .plainText {
          font-size: 16px;
          height: 30px;
          line-height: 24px;
          color: ${colors.black};
          cursor: pointer;
        }

        .highLight {
          font-size: 16px;
          height: 30px;
          line-height: 24px;
          font-weight: 400;
          color: ${colors.hoverBlue};
          white-space: nowrap;
          cursor: pointer;
          text-decoration: underline;
        }
      }
    }
  }

  .warning {
    color: ${colors.red};
    font-size: 14px;
    font-weight: 600;
  }

  .redMark {
    color: ${colors.red};
    font-weight: 600;
  }

  .tooltipContent {
    svg {
      margin: 0 0 0 5px;
    }

    .highLight {
      font-size: 14px;
      font-weight: 600;
      font-style: italic;
      color: ${colors.tooltip};
    }

    .text {
      font-size: 24px;
      font-weight: 600;
    }
  }

  /* .couponContainer {
    position: absolute;
    bottom: -130px;
    left: 0;
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    column-gap: 10px;
    .applyCouponButton {
      margin-top: 7px;
    }
  } */

  label {
    color: ${colors.almostBlack};
    @media only screen and (max-width: ${styleSizes.miniBreakpoint}) {
      font-size: 14px;
    }
  }
`;

export const RoomOptionsContainer = styled(BasicSectionContainer)`
  flex-basis: 60%;
  max-width: 800px;
  min-width: 315px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  margin-top: 64px;
  @media only screen and (max-width: ${styleSizes.tabletBreakpoint}) {
    margin-top: 48px;
  }

  @media only screen and (max-width: 1100px) {
    flex-basis: 50%;
  }
  .noRoomsTitle {
    font-size: 33px;
    color: ${colors.red};
    margin: 20px 0 0 0;
  }

  .noRoomsPicture {
    width: 100%;
    height: 447px;
    background-size: contain;
    background-position: left top;
    background-repeat: no-repeat;
    background-image: url(${noRoomsPicture});
    margin: 20px 0 50px 0;

    @media only screen and (max-width: ${styleSizes.miniBreakpoint}) {
      height: auto;
      background-position: center;
    }
  }

  .roomOptionsTitle {
    font-size: 32px;
    font-weight: 600;
    margin-bottom: 20px;
    @media only screen and (max-width: ${styleSizes.tabletBreakpoint}) {
      margin-bottom: 36px;
    }
    @media only screen and (max-width: ${styleSizes.mobileBreakpoint}) {
      font-size: 24px;
    }
  }

  .roomOptionsFooter {
    font-size: 15px;
    font-style: italic;
    color: ${colors.secLabel};
    margin: 0 0 50px 0;
  }

  .loading {
    font-size: 33px;
    font-weight: 600;
    margin: 20px 0;
  }

  @media only screen and (max-width: ${styleSizes.miniBreakpoint}) {
    width: 100%;
    max-width: 100%;

    .noRoomsTitle {
      text-align: center;
    }

    .noRoomsDescription {
      width: 100%;
      text-align: center;
    }

    .noRoomsPicture {
      width: 100%;
      height: 300px;
      margin: 0;
    }
  }
`;
